<template lang="pug">
  div(class="form-tag")
    h2(class="title-32px bold mb-2") {{ title }}
    div(
      v-if="!isEdit"
      class="text-14px light mb-8"
    ) {{ $t('Help organize documents by providing a convenient way to quickly find, sort and use them') }}
    v-form(@submit.prevent.stop="onSubmit")
      ValidationObserver(
        ref="form"
        slim
      )
        ValidationProvider(
          rules="required"
          vid="name"
          :name="wrapQuotesProviderName($t('Tag name'))"
          v-slot="{ errors }"
          mode="lazy"
        )
          v-text-field(
            v-model="form.name"
            filled
            :error-messages="errors"
            :label="$t('Enter name of new tag')"
          )
        div(class="text-14px light dark mb-4") {{ $t('Choose tag color') }}
        ValidationProvider(
          rules="required"
          vid="color"
          :name="wrapQuotesProviderName($t('Tag color'))"
          v-slot="{ errors }"
          mode="lazy"
        )
          v-radio-group(
            v-model="form.color"
            row
            :error-messages="errors"
            class="form-tag__radio-group"
          )
            v-btn(
              v-for="colorItem in colors"
              :key="colorItem.color"
              icon
              class="form-tag__color-picker"
              @click="selectColor(colorItem.color)"
            )
              div(
                class="form-tag__color"
                :style="{ backgroundColor: colorItem.color }"
              )
                e-svg-icon(
                  size="xs"
                  v-if="colorItem.color === form.color"
                ) check-white
        div(class="form-tag__actions")
          v-btn(
            @click="closeModal"
            height="48"
          ) {{ $t('Cancel') }}
          v-btn(
            type="submit"
            class="main-button"
            :loading="loading"
          ) {{ buttonText }}
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import validate from '~/mixins/validation/validate'

export default {
  name: 'FormTag',
  components: {
    ValidationProvider
  },
  mixins: [validate],
  props: {
    item: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    closeModal: {
      type: Function,
      default: () => {}
    },
    document: {
      type: Object,
      default: null
    },
    documents: {
      type: Array,
      default: null
    },
    tableRequest: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      form: {
        name: null,
        color: null
      }
    }
  },
  computed: {
    colors() {
      return [
        {
          color: '#FF1744'
        },
        {
          color: '#FFA04C'
        },
        {
          color: '#edf111'
        },
        {
          color: '#049541'
        },
        {
          color: '#514FFF'
        },
        {
          color: '#8F257D'
        },
        {
          color: '#121212'
        }
      ]
    },
    title() {
      return this.isEdit ? this.$t('Tag edit') : this.$t('New tag')
    },
    buttonText() {
      return this.isEdit ? this.$t('Save') : this.$t('Create')
    }
  },
  created() {
    if (this.item) {
      this.form.color = this.item.color
      this.form.name = this.item.name
    }
  },
  methods: {
    selectColor(color) {
      this.form.color = color
    },
    async onSubmit() {
      const valid = await this.$refs.form.validate()
      if (!valid) {
        return
      }
      try {
        this.loading = true
        if (this.isEdit) {
          await this.$store.dispatch('tags/update', { id: this.item.id, payload: this.form })
          await this.tableRequest()
        } else {
          const createdTag = await this.$store.dispatch('tags/create', { payload: this.form })
          const payload = {
            tagIds: [createdTag?.id]
          }
          if (this.document) {
            await this.$store.dispatch('documents/addTags', { id: this.document.id, payload })
            await this.$store.dispatch('documents/read', { id: this.document.id })
          }
          if (this.documents && this.documents.length) {
            payload.documentIds = this._.map(this.documents, item => item.id)
            await this.$store.dispatch('documents/attachTags', payload)
            await this.tableRequest()
          }
        }
        this.closeModal()
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.form-tag {
  &__radio-group {
    &::v-deep {
      .v-input--radio-group__input {
        justify-content: space-between;
      }
    }
  }
  &__color-picker {
    width: 40px;
    height: 40px;

    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__color {
    width: 20px;
    height: 20px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;
  }
  &__actions {
    margin-top: 32px;

    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
  }
}
</style>
